export const GET_CONTEST_RESULTS_SUCCESSFUL = "GET_CONTEST_RESULTS_SUCCESSFUL";
export const GET_CONTEST_RESULTS_FAILED = "GET_CONTEST_RESULTS_FAILED";

export const GET_CONTEST_TEAMS_LIST_SUCCESSFUL = "GET_CONTEST_TEAMS_LIST_SUCCESSFUL";
export const GET_TASKS_SUCCESSFUL = "GET_TASK_SUCCESSFUL"
export const GET_TASK_TESTS_SUCCESSFUL = "GET_TASK_TEST_SUCCESSFUL"
export const CREATE_TASK_SUCCESSFUL = "CREATE_TASK_SUCCESSFUL"
export const CREATE_TASK_TEST_SUCCESSFUL = "CREATE_TASK_TEST_SUCCESSFUL"


export const DELETE_TASK_SUCCESSFUL = "DELETE_TASK_SUCCESSFUL"
export const DELETE_TASK_TEST_SUCCESSFUL = "DELETE_TASK_TEST_SUCCESSFUL"


export const SHOW_TASK_DETAILS = "SHOW_TASK_DETAILS";
export const HIDE_TASK_DETAILS = "HIDE_TASK_DETAILS";
export const HIDE_ALL_TASK_DETAILS = "HIDE_ALL_TASK_DETAILS";

